const doc = [({"ja":({"finalPriceInquiry":"最終料金問い合わせ", "consultation":"ご相談"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;